import { ReactElement, ReactNode } from 'react';
import { Brand100 } from '@src/utils/colors';

interface MedianLegendLabelProps {
  children: ReactNode;
}

// The central-measure (median/mean) diamond marker + label shown beneath the saturation
// legend. The diamond svg is identical across both Model Insights widgets; only the label
// text differs (Brand: "{measure} spend"; Business: "{measure} Positive Response"), passed
// as children.
export const MedianLegendLabel = ({ children }: MedianLegendLabelProps): ReactElement => (
  <div className='median-legend-label'>
    <svg width='15' height='15' viewBox='0 0 15 15'>
      <polygon points='7.5,0 15,7.5 7.5,15 0,7.5' fill={Brand100} />
    </svg>
    <div className='median-text'>{children}</div>
  </div>
);
